import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

/* Mixins */
import { BoxSizingSelfAndChildren } from 'styles/Mixins';

/* Utils */
import { opaque, assignIfDefined } from 'styles/Utils';

const CheckBoxColorsMixin = ({
  theme,
  isChecked,
  isDisabled,
}: {
  theme: DefaultTheme;
  isChecked: boolean;
  isDisabled: boolean | undefined;
}) => {
  if (isDisabled) {
    return isChecked
      ? `background-color: ${theme.darkCobalt};
        opacity: 0.35;`
      : `background-color: ${theme.Grey5};`;
  }
  return isChecked
    ? `background-color: ${theme.darkCobalt};`
    : `background-color: ${opaque('#ffffff', 0.5)};
      border: 2px solid ${theme.Grey5};`;
};

export const StyledCheckbox = styled.div<{
  width: string;
  height: string;
  isDisabled: boolean | undefined;
  isChecked: boolean;
  position?: string;
}>`
  display: flex;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: 2px;
  transition: background-color 0.25s linear;
  ${({ isDisabled }) => !isDisabled && 'cursor: pointer'};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};
  ${CheckBoxColorsMixin};
  ${BoxSizingSelfAndChildren};
  ${assignIfDefined('position')};
`;
